// filepath: src/firebase/firestore/useIntelligenceRequests.js
import {useEffect, useState} from 'react';
import {useSession} from '../UserProvider';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch IR documents for the current user.
 * Returns { data, loading, error }.
 */
export function useIntelligenceRequests(options = {}) {
    const {limit = undefined} = options;
    const {user} = useSession() || {user: null};
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!user?.uid) {
            setData([]);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);

        let url = `${BASE}/api/intelligence-requests?type=IR&userId=${encodeURIComponent(user.uid)}`;
        if (typeof limit === 'number' && limit > 0) url += `&limit=${limit}`;

        fetch(url, {headers: authHeaders()})
            .then((r) => r.ok ? r.json() : Promise.reject(new Error(`${r.status}`)))
            .then((list) => { setData(Array.isArray(list) ? list : []); setLoading(false); })
            .catch((err) => { setError(err); setLoading(false); });
    }, [user?.uid, limit]);

    return {data, loading, error};
}
